import { render, staticRenderFns } from "./CreateUserProfileModal.vue?vue&type=template&id=5aefdcde&scoped=true"
import script from "./CreateUserProfileModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./CreateUserProfileModal.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CreateUserProfileModal.vue?vue&type=style&index=0&id=5aefdcde&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aefdcde",
  null
  
)

export default component.exports